import { useNavigate } from "react-router-dom";

export default function BackButton({ fallback = "/home", className = "", compact = false }) {
  const navigate = useNavigate();
  return <button type="button" className={`kl-back-button ${className}`} aria-label="ย้อนกลับ" onClick={() => {
    if (window.history.state?.idx > 0) navigate(-1);
    else navigate(fallback);
  }}><span aria-hidden="true">←</span>{!compact && <span>ย้อนกลับ</span>}</button>;
}
